import { render, staticRenderFns } from "./SearchNavigationOnboarding.vue?vue&type=template&id=49787c78&scoped=true"
import script from "./SearchNavigationOnboarding.vue?vue&type=script&lang=ts"
export * from "./SearchNavigationOnboarding.vue?vue&type=script&lang=ts"
import style0 from "./SearchNavigationOnboarding.vue?vue&type=style&index=0&id=49787c78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49787c78",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/views/home.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Fonboarding%2FSearchNavigationOnboarding.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports